import { PredictionModelDto, VariableValueDto } from '@sharedcommon/rest/data.restservice';
import { VariableDto } from '@sharedcommon/rest/equation.restservice';

export class VariableValue {

    predictionModel: PredictionModelDto;
    variable: VariableDto;
    variableValue: VariableValueDto;

    constructor(pm: PredictionModelDto, v: VariableDto, vv: VariableValueDto) {
        this.predictionModel = pm;
        this.variable = v;
        this.variableValue = vv;
    }
}
